/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Blocked_Stripe_BodyInputs */

const en_premium_blocked_stripe_body = /** @type {(inputs: Premium_Blocked_Stripe_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription is active, so there's nothing to buy here. You can review or change it on your plan page.`)
};

const es_premium_blocked_stripe_body = /** @type {(inputs: Premium_Blocked_Stripe_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu suscripción está activa, así que no hay nada que comprar aquí. Puedes revisarla o cambiarla en la página de tu plan.`)
};

/**
* | output |
* | --- |
* | "Your subscription is active, so there's nothing to buy here. You can review or change it on your plan page." |
*
* @param {Premium_Blocked_Stripe_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_blocked_stripe_body = /** @type {((inputs?: Premium_Blocked_Stripe_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Blocked_Stripe_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_blocked_stripe_body(inputs)
	return en_premium_blocked_stripe_body(inputs)
});